var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nb-progress-bar-default"},[_c('div',{staticClass:"progress-bar-wrapper",class:`step-${_vm.progressVal} ${_vm.addInfoColor}`},[_c('b-progress',{attrs:{"height":`${_vm.height}px`,"max":_vm.max,"value":_vm.progressVal * _vm.step}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }